export default defineNuxtRouteMiddleware((to, from) => {
  const wv = useCookie<string>('wv')
  const q = to.query.layout

  // App deep-links carry ?layout=none only on the first URL; persist it for
  // the session so in-app navigation (e.g. redirect after a reservation)
  // keeps the bare layout even without the wv cookie.
  if (q === 'none') wv.value = '1'

  if (String(wv.value) === '1' || q === 'none') setPageLayout('basic')
})
